import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from "react";
import CardLayout from "components/Settings/components/CardLayout";
import Input from "components/BaseWidgets/form/input";

const ProfileVisibility = forwardRef(
  ({ data, onValuesChange, isLoading }, ref) => {
    const [nameValue, setNameValue] = useState("");
    const [locationValue, setLocationValue] = useState("");
    const [errors, setErrors] = useState({ location: "" });

    useEffect(() => {
      if (data) {
        setNameValue(data.name ?? "");
        setLocationValue(data.location ?? "");
      }
    }, [data]);

    const handleNameChange = (e) => {
      const value = e.target.value;
      setNameValue(value);
      onValuesChange({ name: value, location: locationValue });
    };

    const handleLocationChange = (e) => {
      const value = e.target.value;
      setLocationValue(value);
      setErrors((prev) => ({ ...prev, location: "" }));
      onValuesChange({ name: nameValue, location: value });
    };

    useImperativeHandle(ref, () => ({
      validate: () => {
        let valid = true;
        const newErrors = { location: "" };

        if (!locationValue.trim()) {
          newErrors.location = "Please enter your location!";
          valid = false;
        }

        setErrors(newErrors);
        return valid;
      },
      getValues: () => ({
        name: nameValue,
        location: locationValue,
      }),
    }));

    return (
      <CardLayout title="Customize your profile visibility">
        <div className="personalize-input">
          <Input
            label="Name"
            placeholder="Enter your name"
            value={nameValue}
            onChange={handleNameChange}
            isDisabled={isLoading}
          />
        </div>

        <div className="personalize-input">
          <Input
            label="Location"
            placeholder="Enter your location"
            value={locationValue}
            onChange={handleLocationChange}
            isDisabled={isLoading}
          />
          {errors.location && (
            <p className="text-red-500 text-sm mt-1 warning-message">
              {errors.location}
            </p>
          )}
        </div>
      </CardLayout>
    );
  },
);

export default ProfileVisibility;
